import React from 'react';
import Select from 'react-select';

const CustomSelect = (props) => {
    const {
        input,
        options,
        onChange: customOnChange,
        meta: { touched, error },
        placeholder,
        submitted,
        isSearchable,
        isClearable,
        'data-cy': dataCy,
        className,
        selectClassName,
        border,
        height,
    } = props;
    return (
        <div className={`form__form-group-input-wrap ${className}`}>
            <Select
                {...input}
                className={`basic-single ${selectClassName}`}
                styles={{
                    control: (provided) => ({
                        ...provided,
                        height: height,
                        border: border,
                        borderRadius: '25px',
                    }),
                    menuList: (provided) => ({
                        ...provided,
                        maxHeight: 200,
                    }),
                }}
                onChange={(value) => {
                    value !== null
                        ? input.onChange(value.value)
                        : input.onChange(value)
                    
                    if (typeof customOnChange === 'function') {
                        customOnChange(value);
                    }
                }}
                onBlur={(event) => event.preventDefault()}
                options={options}
                isSearchable={isSearchable}
                isClearable={isClearable}
                placeholder={placeholder}
                isDisabled={submitted}
                value={
                    input.value === ''
                        ? null
                        : options.find((obj) => obj.value === input.value)
                }
                classNamePrefix="react-select"
                id={dataCy}
            />
            {touched && error && (
                <span
                    className="form__form-group-error text-justify"
                    data-cy={`${dataCy}--error`}
                >
                    {error}
                </span>
            )}
        </div>
    );
};

CustomSelect.defaultProps = {
    placeholder: '',
    type: 'text',
    options: [],
    value: 0,
    meta: {
        touched: false,
        error: '',
    },
    submitted: false,
    isSearchable: false,
    isClearable: false,
    'data-cy': undefined,
};

export default CustomSelect;
